<div class="column" [class.column-sm]="column.static">
  <div>-</div>
</div>
